"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureExpCodeUsage = void 0;
const createApi_1 = require("../../../helpers/createApi");
const schemas_1 = require("./schemas");
const list = (caller) => async ({ accountId, flagId }) => {
    return caller(`/accounts/${accountId}/flags/${flagId}/flag_usages`)
        .get()
        .then(schemas_1.FeatureExpCodeUsagesWithPaginationSchema.parse);
};
exports.featureExpCodeUsage = (0, createApi_1.createAPIFactory)({
    list,
});
//# sourceMappingURL=api.js.map